import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import pr1 from '../assets/pr1.jpg';
import pr2 from '../assets/pr2.jpg';
import pr3 from '../assets/pr3.jpg';
import pr4 from '../assets/pr4.jpg';
import pr5 from '../assets/pr5.jpg';
import pr6 from '../assets/pr6.jpg';
import pr7 from '../assets/pr7.jpg';
import pr8 from '../assets/pr8.jpg';
import pr9 from '../assets/pr9.jpg';
import pr10 from '../assets/pr10.jpg';
import pr11 from '../assets/pr11.jpg';
import pr12 from '../assets/pr12.jpg';
import re1 from '../assets/re1.jpeg';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";
import org1 from '../assets/org1.png';
import customers from '../assets/customers.png';


export default function CustomersBanner(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>

					

					<div className="row">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Our Esteemed Customers
							</h6>
						</div>

						<div className="col-md-6 mDesktopOnly">
							<img
								src={customers}
								style={{
									width: "100%",
								}}
							/>
						</div>	

						<div className="col-md-6 mDesktopOnly">
							<img
								src={customers}
								style={{
									width: "100%",
								}}
							/>
						</div>	

						<div className="col-md-6 mMobileOnly">
							<img
								src={customers}
								style={{
									width: "100%",
								}}
							/>
						</div>	

					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
